import { createContext, useContext } from 'react';

/*
 * Split from AuthProvider so the provider file exports only components. Vite's
 * fast refresh bails on a module that mixes components with other exports, and
 * losing state on every save while building a login form is miserable.
 */
export const AuthContext = createContext(null);

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }

  return context;
}
